import type { SdkHandlersProvider, ServiceProvider } from '@wix/thunderbolt-symbols'
import { withDependencies } from '@wix/thunderbolt-ioc'
import type { FactoryWithDependencies } from '@wix/thunderbolt-ioc'
import type { INamedSignalsServiceConfig, INamedSignalsDefinition } from '@wix/viewer-service-named-signals/definition'
import { NamedSignalsDefinition as definition } from '@wix/viewer-service-named-signals/definition'
import { NamedSignalsService as impl } from '@wix/viewer-service-named-signals/implementations'
import type { SsrSignalsSdkHandlers } from './types'
import { NamedSignalsHandlersSymbol } from './symbols'

export const NamedSignalsServiceClient: FactoryWithDependencies<ServiceProvider<INamedSignalsDefinition, typeof impl>> =
	withDependencies(
		[NamedSignalsHandlersSymbol],
		(namedSignalsHandlers): ServiceProvider<INamedSignalsDefinition, typeof impl> => {
			const config: INamedSignalsServiceConfig = {
				onRemoteChange: async (cb) => {
					namedSignalsHandlers.onPlatformChange(cb)
				},
				updateRemote: async (name, value) => {
					namedSignalsHandlers.updatePlatform(name, value)
				},
			}

			return {
				definition,
				impl,
				config,
				hasNonSerializablePlatformConfig: true,
			}
		}
	)

export const NamedSignalsServiceServer: FactoryWithDependencies<
	ServiceProvider<INamedSignalsDefinition, typeof impl> & SdkHandlersProvider<SsrSignalsSdkHandlers>
> = withDependencies(
	[],
	(): ServiceProvider<INamedSignalsDefinition, typeof impl> & SdkHandlersProvider<SsrSignalsSdkHandlers> => {
		const store: Record<string, any> = {}

		const config: INamedSignalsServiceConfig = {
			onRemoteChange: async () => {},
			updateRemote: async () => {},
		}

		return {
			definition,
			impl,
			config,
			hasNonSerializablePlatformConfig: true,
			platformConfig: { initialStore: store }, // will be used for service init in builder-component isolate

			getSdkHandlers: () => ({
				ssrSignals: {
					updateRemote: (name: string, value: any) => (store[name] = value),
				},
			}),
		}
	}
)
